import { FascicoloFull } from '../../../../common/models/fascicolo/fascicolo-full';
import { SoggettoPratica } from '../../../../common/models/tipologiche/soggetto-pratica';

export class FascicoloGestioneAmministrativa extends FascicoloFull {
  dataApertura: number;
  dataRichiesta: number;
  richiesta: string;
  societa: SoggettoPratica;
  constructor() {
    super();
    this.dataApertura = + new Date();
    this.dataInizioFascicolo = + new Date();
  }
}
